import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { PreferencesService } from '../../../services/preferences/preferences.service';
import { InvestmentGoal } from '../../../domain/lti/lti.domain';

import { GoalRestService } from './goal-rest.service';

@Injectable({
  providedIn: 'root'
})
export class GoalService {
  private readonly goalRestService = inject(GoalRestService);
  private readonly preferencesService = inject(PreferencesService);

  /**
   * Get goal by id
   *
   * @return
   */
  getGoal(goalId: string): Observable<InvestmentGoal> {
    return this.goalRestService.getGoal(goalId);
  }

  /**
   * Returns an observable saying if the user has created a goal before or not
   */
  hasGoalEverBeenCreated(): Observable<boolean> {
    return this.preferencesService.getUserPreference<boolean>('HAS_EVER_CREATED_GOAL');
  }

  /**
   * Post goal
   *
   * @param
   * @return
   */
  createGoal(goal: InvestmentGoal): Observable<InvestmentGoal> {
    return this.goalRestService.createGoal(goal).pipe(
      map((investmentGoal: InvestmentGoal): InvestmentGoal => {
        this.updateHasEverCreatedGoal();
        return investmentGoal;
      }));
  }

  /**
   * Patch goal
   *
   * @param
   * @return
   */
  updateGoal(id: string, goal: InvestmentGoal): Observable<InvestmentGoal> {
    return this.goalRestService.updateGoal(id, goal);
  }

  private updateHasEverCreatedGoal(): void {
    this.preferencesService.getUserPreference<boolean>('HAS_EVER_CREATED_GOAL').subscribe((hasEverreatedGoal: boolean): void => {
      if (hasEverreatedGoal !== true) {
        this.preferencesService.refreshUserPreferences();
      }
    });
  }
}

